// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"adminBar__gradient-bg5__fNjlk","adminBar":"adminBar__adminBar__qVcj1"};